import { render, staticRenderFns } from "./DirectIncomingRB.vue?vue&type=template&id=90e91388&scoped=true&"
import script from "./DirectIncomingRB.vue?vue&type=script&lang=js&"
export * from "./DirectIncomingRB.vue?vue&type=script&lang=js&"
import style0 from "./DirectIncomingRB.vue?vue&type=style&index=0&id=90e91388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e91388",
  null
  
)

export default component.exports